export default __webpack_public_path__ + "static/media/logo.5ace3bef.webp";